<template>
    <div>
        <TheHeader class="pc-header"  />
        <BaseTitle :infor="infor" />
        <div class="banner">
            <img :src="infor.banner">
        </div>
        <BaseArcticle :list="infor.list" />
        <AboutUsPhoto :list="infor.member" />
        <TheFooter class="pc-the-footer-other" />
    </div>
</template>

<script>

    import TheHeader from '@/components/module/TheHeader'
    import TheFooter from '@/components/module/TheFooter'
    import '@/assets/less/module/module-the-header_pc-header.less'
    import '@/assets/less/module/module-the-footer-other_pc-the-footer-other.less'
    
    import BaseTitle from '@/components/module/BaseTitle'
    import BaseArcticle from '@/components/module/BaseArcticle'
    import AboutUsPhoto from '@/components/module/AboutUsPhoto'

    export default {
        name: 'PCAboutUs',
        props: {
            infor: Object
        },
        components: {
            TheHeader,
            TheFooter,
            BaseTitle,
            BaseArcticle,
            AboutUsPhoto
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.detail-acticle {
    padding-top: 50px;
    padding-bottom: 30px;
}

</style>